module.exports = __webpack_public_path__ + "static/media/logo-small.165f1401.svg";